

























































import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';
import { customerOptionalForm } from '@/constants/form/customerForm';
import {
  registerFinishText,
  registerFinishAction,
  authorityValidMessage,
  authorityInvalidMessage,
  CustomerRegisterActionButton,
  toolTipsMessage
} from '@/constants/customer/customer';
import {
  FieldChildrenProp,
  ActionFieldSeeting,
  GetInputFieldsActons
} from '@/services/hexabase/types';
import { customerRules } from '@/constants/form/inputCheck';

import Customer from '@/models/customerModel';

import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import SampleAction from '@/components/sample/detail/SampleAction.vue';
import CreateBasicInfo from '@/components/sample/detail/CreateBasicInfo.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import { DateTime } from 'luxon';

import CustomerBasicInfoPanel from '@/components/customer/detail/CustomerBasicInfoPanel.vue';

interface RegistCustomerDepertitem {
  department_name: string;
  department_name_kana: string;
  department_id?: string;
  head_office_judgment_flag: string;
  postal_code?: string;
  prefectures?: string;
  municipalities?: string;
  machimura_street_address?: string;
  building_name?: string;
  manager?: string;
  manager_email?: string;
  telephone_number?: string;
  cell_phone_number?: string;
}
interface SelectOptions {
  option_id: string;
  sort_id: 0;
  value: string;
  enabled: true;
  color: string;
  display_id: string;
  text: string;
}
/** ヘキサベースのID値を参照するためのエリア：事前設定必要 */
interface ReferenceValueArea {
  /**本社拠点フラグ：本社 */
  head_office_judgment_flag_head_office: string;
  /**本社拠点フラグ：拠点 */
  head_office_judgment_flag_department: string;
  /**顧客区分：法人 */
  customer_class_houjin: string;
  /**顧客区分：個人 */
  customer_class_kojin: string;
}

@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    SampleAction,
    CreateBasicInfo,
    TransitionDialog,
    Dialog,
    CustomerBasicInfoPanel,
    ExecAction
  },
  beforeRouteEnter(to: Route, from: Route, next: any): void {
    next((vm: any) => {
      vm.prevRoute = from;
      next();
    });
  }
})
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
export default class CustomerRegister extends Vue {
  private projectId = hexabaseState.applicationId;
  private customer = new Customer();
  private prevRoute: any = null;

  // 各入力フィールド情報格納プロパティ
  private basicFieldsData: Array<FieldChildrenProp> = [];
  private basicFieldCols = '';
  private statusButton = CustomerRegisterActionButton;
  private subPanelListName = '部署・拠点情報';
  private subPanelLabel = '';
  private subPanelFieldCols: any = [];
  private subPanelFieldsData: Array<Array<FieldChildrenProp>> = [];

  // dbID格納プロパティ
  private mainDsId = '';
  private relatedDsId = '';

  // 登録用情報格納プロパティ
  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {}, // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };
  private registFieldType: any = {};

  // アイテム登録後ダイアログ
  private dialogStatus = false;
  private isLoading = false;
  private registerText = '';
  private buttons: Array<{ [k: string]: string | number }> = this.customer.deepCopy(
    registerFinishAction
  );

  // 発注の初期ステータス
  private displayStatus = '';

  private registAuthority = false;
  private guideMessage = '';
  private basicNewAction: any = [];
  private unshowdId = ['birthday', 'sex'];

  private CustomerDepertitem: RegistCustomerDepertitem = {
    department_name: '',
    department_name_kana: '',
    department_id: '',
    head_office_judgment_flag: '',
    postal_code: '',
    prefectures: '',
    municipalities: '',
    machimura_street_address: '',
    building_name: '',
    manager: '',
    manager_email: '',
    telephone_number: '',
    cell_phone_number: ''
  };

  private defaultOption: SelectOptions = {
    option_id: '',
    sort_id: 0,
    value: '',
    enabled: true,
    color: '',
    display_id: '',
    text: ''
  };

  private referenceValue: ReferenceValueArea = {
    head_office_judgment_flag_head_office: '',
    head_office_judgment_flag_department: '',
    customer_class_houjin: '',
    customer_class_kojin: ''
  };

  private ActionButtonType = 'register_cancel';
  private isExecDialog = false;
  private execDialogMessage = '重複するデータが存在します。登録を続けますか？';
  private execDialogTitle = '登録確認';

  /** 顧客基本情報インフォ用 */
  private toolTipsTextBasicInfoMain = '';
  /** 顧客部署リストインフォ用 */
  private toolTipsTextBasicInfoDepartmentList = '';
  /** 案件情報リストインフォ用 */
  private toolTipsTextBasicInfoMatterList = '';

  async created() {
    if (this.$route.query.querytest !== undefined) {
      this.ActionButtonType = String(this.$route.query.querytest);
    }

    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);

      this.mainDsId = hexabaseState.datastoreIds['顧客マスタ'];
      this.relatedDsId = hexabaseState.datastoreIds['顧客部署マスタ'];

      // tooltips情報を後設定出来るよう修正
      this.toolTipsTextBasicInfoMain = this.customer.deepCopy(
        toolTipsMessage['customer_toolTipsTextBasicInfoMain']
      );
      this.toolTipsTextBasicInfoDepartmentList = this.customer.deepCopy(
        toolTipsMessage['customer_toolTipsTextDepartmentList']
      );
      this.toolTipsTextBasicInfoMatterList = this.customer.deepCopy(
        toolTipsMessage['customer_toolTipsTextMatterList']
      );

      // 入力フィールド情報を取得
      await this.getBasicFields();

      // 初期値の設定
      await this.setInitialValue();

      // 権限を取得する
      // デフォルトの新規登録アクション以外を取得できていないなら発注登録権限を持たない
      this.registAuthority = this.basicNewAction !== undefined ? true : false;
      this.guideMessage = this.registAuthority ? authorityValidMessage : authorityInvalidMessage;
    } catch (e) {
      console.log(e);
      this.setError(e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * 基本情報入力フォームを生成するための設定情報を取得・整形します
   */
  private async getBasicFields() {
    try {
      const newAction = await this.customer.getNewActionList(this.mainDsId).then(data => {
        return data;
      });
      this.basicNewAction = newAction.actions.find(v => v.display_id === 'customer_register');
      const [inputFields, fieldsData, fieldsData2] = await Promise.all([
        this.customer.getFieldsByActionId(this.mainDsId, newAction.actions[0].action_id),
        this.customer.makeFieldsList(this.projectId, this.mainDsId),
        this.customer.makeFieldsList(this.projectId, this.relatedDsId)
      ]);
      this.basicNewAction = newAction.actions.find(v => v.display_id === 'customer_register');
      // データ登録時の為各フィールドのデータ型を格納
      for (const key in inputFields.action_fields) {
        this.registFieldType[inputFields.action_fields[key].display_id] =
          inputFields.action_fields[key].dataType;
      }

      const data = this.customer
        .addOptionalFormField(
          fieldsData.filter(v => v.dataType !== 'status'),
          this.customer.deepCopy(customerOptionalForm),
          true
        )
        .map(field => this.customer.inputRestriction(field, inputFields))
        .map(field => {
          // フィールドの初期値・登録データ初期値
          this.registData.item = {
            ...this.registData.item,
            ...this.customer.setRregistData(field, inputFields)
          };
          return this.customer.setSelected(field, inputFields);
        })
        .map(v => {
          if (v.registProps !== undefined && v.registProps!['setting'] !== undefined) {
            const stateKey = v.registProps!['setting']!.key!;
            switch (stateKey) {
              case 'getUserDepartmentId': {
                v.props!.value = { item_id: userState.getUserDepartmentId };
                break;
              }
              case 'getUserEmployeeId': {
                v.props!.value = { item_id: userState.getUserEmployeeId };
                break;
              }
              case 'getOrderApplicationDate': {
                v.props!.value = DateTime.local().toString();
                break;
              }
              default:
                break;
            }
          }
          return v;
        });

      // ID値を退避
      await this.setReferenceArea(fieldsData, fieldsData2);

      // フォーカス調整のため要素を並べ替え
      const sortwk1 = data.sort(function(a, b) {
        return (a.col || 0) - (b.col || 0);
      });
      const sortwk2 = sortwk1.sort(function(a, b) {
        return (a.row || 0) - (b.row || 0);
      });
      this.basicFieldCols = this.customer.getGridStatus(sortwk2);
      this.basicFieldsData = (await this.modifyFields(
        this.mainDsId,
        sortwk2,
        inputFields,
        'customer_regist'
      )) as Array<FieldChildrenProp>;
    } catch (error) {
      console.log(error);
      this.setError(error);
    }
  }

  /**
   * 選択値等IDが必要なものを参照するために事前セットをする
   */
  private async setReferenceArea(
    fieldsData1: Array<FieldChildrenProp>,
    fieldsData2: Array<FieldChildrenProp>
  ) {
    // 顧客区分
    const index_cco = fieldsData1.findIndex(v => v.display_id === 'customer_class');
    const wk_cco: any = fieldsData1[index_cco];
    const customer_class_option: Array<SelectOptions> = wk_cco.options || this.defaultOption;
    this.referenceValue.customer_class_houjin =
      customer_class_option.find(V => V.text === '法人')?.option_id || '';
    this.referenceValue.customer_class_kojin =
      customer_class_option.find(V => V.text === '個人')?.option_id || '';
    // 顧客マスタ＿本社拠点判定用フラグ
    const index_jfd = fieldsData2.findIndex(v => v.display_id === 'head_office_judgment_flag');
    const wk_jfd: any = fieldsData2[index_jfd];
    const head_office_judgment_flag_option: Array<SelectOptions> =
      wk_jfd.options || this.defaultOption;
    this.referenceValue.head_office_judgment_flag_head_office =
      head_office_judgment_flag_option.find(V => V.text === '本社')?.option_id || '';
    this.referenceValue.head_office_judgment_flag_department =
      head_office_judgment_flag_option.find(V => V.text === '拠点部署')?.option_id || '';
  }

  /**
   * 子コンポーネントからEmitされる値インサート用に加工（基本情報）
   * 主にPropsの変更を行う
   * @module catchInputBasic
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private catchInputBasic(response: any) {
    const index = this.basicFieldsData.findIndex(v => v.display_id === response.name);
    switch (this.basicFieldsData[index].component) {
      case 'MasterSelectControl':
      case 'MasterSelectSetControl':
      case 'MasterSelectMultiControl':
      case 'MasterSelectMultiSetControl':
        this.$set(this.basicFieldsData[index].props!, 'value', { item_id: response.value });
        break;
      default:
        this.$set(this.basicFieldsData[index].props!, 'value', response.value);
    }
    if (
      response.name !== undefined &&
      response.text !== undefined &&
      response.name === 'customer_class'
    ) {
      switch (response.text) {
        case '法人': {
          const indexH1 = this.basicFieldsData.findIndex(v => v.display_id === 'birthday');
          const indexH2 = this.basicFieldsData.findIndex(v => v.display_id === 'sex');
          const indexH3 = this.basicFieldsData.findIndex(v => v.display_id === 'corporate_number');
          this.$set(this.basicFieldsData[indexH1], 'show', false);
          this.$set(this.basicFieldsData[indexH2], 'show', false);
          this.$set(this.basicFieldsData[indexH3], 'show', true);
          // バリデーションルールを付与する
          this.$set(this.basicFieldsData[indexH3].props!, 'rules', 'numeric|corporate_number_lengthCheck:13');
          break;
        }
        case '個人': {
          const indexK1 = this.basicFieldsData.findIndex(v => v.display_id === 'birthday');
          const indexK2 = this.basicFieldsData.findIndex(v => v.display_id === 'sex');
          const indexH3 = this.basicFieldsData.findIndex(v => v.display_id === 'corporate_number');
          this.$set(this.basicFieldsData[indexK1], 'show', true);
          this.$set(this.basicFieldsData[indexK2], 'show', true);
          this.$set(this.basicFieldsData[indexH3], 'show', false);
          // バリデーションルールを削除する
          this.$set(this.basicFieldsData[indexH3].props!, 'rules', '');
          break;
        }
      }
    }
  }

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  private getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta.breadcrumbs;
    }
    return [];
  }

  /**
   * 初期値セット
   */
  private async setInitialValue() {
    // 登録日に初期値としてシステム日付をセット
    if (this.basicFieldsData.length !== 0) {
      this.$set(
        this.basicFieldsData[
          this.basicFieldsData.findIndex(v => v.display_id === 'registration_date')
        ]['props']!,
        'value',
        DateTime.local().toString()
      );
    }
    this.$set(
      this.registData['item']!,
      'registration_date',
      DateTime.local()
    );
  }

  /**
   * 基本情報パネルで入力された値を受け取り登録データに渡す
   * @public response - インサート用に整形されたデータ
   * @returns void
   */
  private createBasicData(response: any): void {
    this.registData.item = response;
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async execAction(type: any) {
    /** 停止フラグ **/
    let StpFlg = false;

    /** ボタンタイプで分岐 **/
    switch (type) {
      case 'register': {
        try {
          //// ローディングをセット
          this.$store.commit('hexabase/setIsLoading', true);
          //更新前に入力型をセットしなおす
          Object.keys(this.registData.item).forEach(key => {
            const dataType = this.registFieldType[key];
            switch (dataType) {
              case 'number':
                this.registData.item[key] = Number(this.registData.item[key]);
                break;
            }
          });

          // 重複チェックの呼び出し
          StpFlg = await this.isDuplicated();
          //重複判定後
          if (StpFlg) {
            //保存中断
            return false;
          } else {
            //保存続行
            await this.execDataRegister(false);
          }
        } catch (e) {
          console.log(e);
          this.registerText = 'エラーにより処理できませんでした';
          this.buttons.splice(0);
          this.buttons.push({ id: 1, type: 'cancel', name: 'cancel', value: '閉じる' });
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
          if (!StpFlg) {
            //正常終了もしくはエラー終了時は終了・遷移ダイアログ
            this.dialogStatus = true;
          } else {
            //重複発生時は重複確認ダイアログ
            this.isExecDialog = true;
          }
        }
        break;
      }
      case 'cancel': {
        this.$router.push({ name: this.prevRoute.name, params: this.prevRoute.params, query: {} });
        break;
      }
    }
  }

  /**
   * 重複判定部
   * 「顧客名」「電話番号」の組み合わせで重複判定を行う
   * @returns {boolean} 重複有りの場合true
   */
  private async isDuplicated() {
    let retFlg = false;
    await this.customer.getMasterData();
    const masterData = this.customer.getMaster();

    const alreadyData = masterData.m_customer.body.filter(
      v => v.customer_name === this.registData.item['customer_name'] && v.Status === '有効'
    );
    // 電話番号重複対象リスト
    const chkTelno =
      this.registData.item['telephone_number'] !== undefined
        ? this.registData.item['telephone_number'].replace(/-/g, '')
        : '';
    if (alreadyData !== undefined && alreadyData.length !== 0) {
      if (chkTelno === undefined || chkTelno.length === 0) {
        retFlg = true;
      } else {
        alreadyData.forEach(i => {
          if (
            i.telephone_number !== undefined &&
            i.telephone_number.replace(/-/g, '') === chkTelno
          ) {
            retFlg = true;
          }
        });
      }
    }
    return retFlg;
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  private registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
  }

  async modifyFields(
    dbId: string,
    data: Array<FieldChildrenProp> | Array<FieldChildrenProp[]>,
    inputFields: GetInputFieldsActons,
    type: string
  ) {
    data = this.addInputRules(
      data as Array<FieldChildrenProp>,
      inputFields.action_field_settings,
      type
    );
    return this.modifyInputAllow(data, inputFields.action_field_settings) as Array<
      FieldChildrenProp
    >;
  }

  addInputRules(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting },
    type: string
  ) {
    return fields.map(field => {
      if (field.props === undefined) return field;

      const ruleArray = [];

      // Hexa側設定必須項目
      if (fieldSetting[field.field_id] !== undefined) {
        // 必須項目確認
        if (fieldSetting[field.field_id].mandatory) {
          const requiredName = field.component === 'SelectArea' ? 'selectRequired' : 'required';
          ruleArray.push(requiredName);
        }
      }
      // アプリ側設定項目
      if (
        customerRules.customer_regist !== undefined &&
        customerRules.customer_regist[type] !== undefined
      ) {
        const row = customerRules.customer_regist[type].find(val => val.id === field.display_id);
        if (row !== undefined) {
          ruleArray.push(row.rule);
        }
      }

      if (field.props!['rules'] === undefined) {
        field.props!['rules'] = '';
      }
      if (ruleArray.length > 0) field.props!['rules'] = ruleArray.join('|');
      return field;
    });
  }

  modifyInputAllow(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting }
  ) {
    return fields.map(field => {
      if (fieldSetting[field.field_id] !== undefined) {
        const row = fieldSetting[field.field_id];
        if (row.update && !field.props!.isDisabled) {
          field.props! = { ...field.props!, ...{ isDisabled: false, isReadonly: false } };
        }
        if (field.dataType === 'dslookup') {
          field.props!.isBtnVisible = true;
          field.props!.isLeftSideInputReadOnly = false;
        }
        this.unshowdId.forEach(i => {
          if (field.display_id === i) {
            row.show = false;
          }
        });
        field = {
          ...field,
          ...{
            show: row.show,
            update: row.update,
            mandatory: row.mandatory
          }
        };
      }
      return field;
    });
  }

  private async clearExecDialog(response: any): Promise<boolean> {
    this.isExecDialog = false;
    if (response !== undefined && response.isAgree) {
      //確認後強行パターン
      await this.execDataRegister(true);
    }
    return true;
  }

  /**
   * 登録実行部：再利用するため外部に切り出し
   *
   **/
  private async execDataRegister(toDialog: boolean): Promise<boolean> {
    try {
      if (toDialog) {
        this.$store.commit('hexabase/setIsLoading', true);
      }

      // 顧客ID（システム付番）をセット
      const autoNumber = await this.customer.getAutoNumber(
        this.projectId,
        this.mainDsId,
        'id',
        userState.getCutomerBranchKey ? {
          branch_key: userState.getCutomerBranchKey,
          zero_padding: 'true',
          digit: '5'
        } : {}
      );
      this.$set(this.registData.item, 'customer_id', autoNumber.result.value);

      //顧客区分が法人の場合「生年月日＆性別」をクリアする
      if (this.registData.item['customer_class'] === this.referenceValue.customer_class_houjin) {
        // 法人の場合
        // 部署名：本社
        this.CustomerDepertitem.department_name = '本社';
        this.CustomerDepertitem.department_name_kana = 'ホンシャ';
        // 生年月日をクリア
        if (this.registData.item['birthday'] !== undefined) {
          this.$delete(this.registData.item, 'birthday');
        }
        // 性別をクリア
        if (this.registData.item['sex'] !== undefined) {
          this.$delete(this.registData.item, 'sex');
        }
      } else {
        // 個人の場合
        // 部署名：顧客名をセット
        this.CustomerDepertitem.department_name = this.registData.item['customer_name'];
        this.CustomerDepertitem.department_name_kana = this.registData.item['customer_kana'];
        // 法人番号をクリア
        if (this.registData.item['corporate_number'] !== undefined) {
          this.$delete(this.registData.item, 'corporate_number');
        }
      }

      // ０番拠点（本社）を関連データとしてセット
      this.CustomerDepertitem.head_office_judgment_flag = this.referenceValue.head_office_judgment_flag_head_office;
      this.CustomerDepertitem.postal_code = this.registData.item['postal_code'];
      this.CustomerDepertitem.prefectures = this.registData.item['prefectures'];
      this.CustomerDepertitem.municipalities = this.registData.item['municipalities'];
      this.CustomerDepertitem.machimura_street_address = this.registData.item[
        'machimura_street_address'
      ];
      this.CustomerDepertitem.building_name = this.registData.item['building_name'];
      this.CustomerDepertitem.manager = this.registData.item['manager'];
      this.CustomerDepertitem.manager_email = this.registData.item['manager_email'];
      this.CustomerDepertitem.telephone_number = this.registData.item['telephone_number'];
      this.CustomerDepertitem.cell_phone_number = this.registData.item['cell_phone_number'];
      //新規登録として顧客部署データをセット
      this.$set(this.registData.related_ds_items, this.relatedDsId, [
        {
          operation: 1,
          link_to_parent: true,
          item: this.CustomerDepertitem
        }
      ]);

      const result = await this.customer.registerLinkedItems(
        hexabaseState.applicationId,
        this.mainDsId,
        this.registData
      );
      this.customer.apiErrorHandle('CREATEITEM', result);
      this.registerText = this.customer.deepCopy(registerFinishText);
      this.buttons.map(v => {
        if (v.name === 'toEdit') {
          v.route = String(v.route).replace(':id', result.item_id);
        }
      });
    } catch (error) {
      console.log(error);
      this.registerText = 'エラーにより処理できませんでした';
      this.buttons.splice(0);
      this.buttons.push({ id: 1, type: 'cancel', name: 'cancel', value: '閉じる' });
    } finally {
      if (toDialog) {
        this.$store.commit('hexabase/setIsLoading', false);
        this.dialogStatus = true;
      }
    }
    return true;
  }

  private setError(errorMessage: string): void {
    if (typeof errorMessage === 'object') errorMessage = this.customer.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit("hexabase/setIsError", true);
    this.$store.commit("hexabase/setErrorMessage", errorMessage);
  }  
}
